/** Normalize list payloads: raw array or `{ data: [] }` / `{ Data: [] }`. */
export function parseListPayload(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.Data)) return data.Data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.Items)) return data.Items;
  return [];
}

export function extractLeaveListStats(rows) {
  const first = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
  return {
    total: Number(first?.totalCount ?? 0),
    pending: Number(first?.pendingCount ?? 0),
    approved: Number(first?.approvedCount ?? 0),
    rejected: Number(first?.rejectedCount ?? 0),
    cancelled: Number(first?.cancelledCount ?? 0),
  };
}

export function extractAttendanceSummary(rows, rawResponse = null) {
  const envelope = rawResponse?.stats ?? rawResponse?.Stats ?? null;
  const first = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
  return {
    totalRecords: Number(
      envelope?.totalRecords ??
        envelope?.TotalRecords ??
        first?.totalRecords ??
        first?.TotalRecords ??
        0
    ),
    thisMonthTotal: Number(
      envelope?.thisMonthTotal ??
        envelope?.ThisMonthTotal ??
        first?.thisMonthTotal ??
        first?.ThisMonthTotal ??
        0
    ),
    thisWeekTotal: Number(
      envelope?.thisWeekTotal ??
        envelope?.ThisWeekTotal ??
        first?.thisWeekTotal ??
        first?.ThisWeekTotal ??
        0
    ),
  };
}

export function extractAssignmentSummary(rows, rawResponse = null) {
  const envelope = rawResponse?.Stats ?? rawResponse?.stats ?? null;
  const first = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
  return {
    totalRecords: Number(
      envelope?.TotalRecords ??
        envelope?.totalRecords ??
        first?.TotalRecords ??
        first?.totalRecords ??
        0
    ),
    thisMonthTotal: Number(
      envelope?.ThisMonthTotal ??
        envelope?.thisMonthTotal ??
        first?.ThisMonthTotal ??
        first?.thisMonthTotal ??
        0
    ),
    todayTotal: Number(
      envelope?.TodayTotal ??
        envelope?.todayTotal ??
        first?.TodayTotal ??
        first?.todayTotal ??
        0
    ),
    thisWeekTotal: Number(
      envelope?.ThisWeekTotal ??
        envelope?.thisWeekTotal ??
        first?.ThisWeekTotal ??
        first?.thisWeekTotal ??
        0
    ),
    totalEstablishments: Number(
      envelope?.TotalEstablishments ??
        envelope?.totalEstablishments ??
        first?.TotalEstablishments ??
        first?.totalEstablishments ??
        0
    ),
  };
}

/** Teacher/list envelope: `{ data: [], stats: { totalTeachers, totalResults, categoryCounts, filters } }` */
export function extractTeacherListStats(rows, rawResponse = null) {
  const envelope = rawResponse?.stats ?? rawResponse?.Stats ?? null;
  const first = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
  return {
    totalTeachers: Number(
      envelope?.totalTeachers ??
        envelope?.TotalTeachers ??
        first?.totalTeachers ??
        first?.TotalTeachers ??
        0
    ),
    totalResults: Number(
      envelope?.totalResults ??
        envelope?.TotalResults ??
        first?.totalResults ??
        first?.TotalResults ??
        0
    ),
  };
}

/** Map stats.categoryCounts → panel category tabs (1–4). */
export function extractTeacherCategoryCounts(rawResponse = null) {
  const cc = rawResponse?.stats?.categoryCounts ?? rawResponse?.stats?.CategoryCounts ?? {};
  return {
    1: Number(cc.all ?? cc.All ?? 0),
    2: Number(cc.unallocated ?? cc.Unallocated ?? 0),
    3: Number(cc.allocated ?? cc.Allocated ?? 0),
    4: Number(cc.allocatedWithAttendance ?? cc.AllocatedWithAttendance ?? 0),
  };
}

export function extractEstablishmentListStats(rows) {
  const first = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
  return {
    totalRecords: Number(
      first?.totalRecords ??
        first?.TotalRecords ??
        first?.totalCount ??
        first?.TotalCount ??
        first?.totalResults ??
        first?.TotalResults ??
        0
    ),
  };
}

export function totalPagesFromCount(totalCount, pageSize) {
  const total = Math.max(0, Number(totalCount) || 0);
  const size = Math.max(1, Number(pageSize) || 10);
  return Math.max(1, Math.ceil(total / size));
}
